module.exports = __webpack_public_path__ + "static/media/errorpurple.cda88941.svg";